import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";

export const interfaceConfig: InterfaceConfig = {
  name: "finbra",
  interest_rate: 36,
  textos_tofu: {
    pm: {
      datos_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo:
          "En caso de tener más de un accionista en igualdad de acciones,\ningresar al que además funja como Representante Legal",
      },
    },
  },
  cotizador: {
    estimated_amount_text:
      "*Esta simulación es para fines demostrativos y está sujeto \na aprobación, las condiciones como la tasa, el monto del \ncrédito, o la comisión por apertura, podrían cambiar \ndependiendo el perfil y la situación actual del solicitante.",
    has_quotation_table: true,
  },
  maps: {
    api_key:
      import.meta.env.VITE_ENV === "PROD"
        ? "AIzaSyDAtCLTqWu3XTjTC6AT2ZysdXUtL33bAX4"
        : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  companyNames: ["Litore Avances SAPI de CV SOFOM ENR", "Lendit Group SAPI de CV"],
  firma: {
    provider: "mifiel",
    condiciones_credito: {
      monto: true,
      plazo: true,
      tasa: false,
    },
    habilitar_calendario_pagos: true,
    habilitar_tabla_amortizacion: true,
  },
  formularios: {
    informacion_bancaria_empresa: {
      numero_estados_cuenta: 6,
    },
    informacion_bancaria_aval: {
      numero_estados_cuenta: 6,
    },
    informacion_bancaria_pfae: {
      numero_estados_cuenta: 6,
    },
    informacion_bancaria_segundo_aval: {
      numero_estados_cuenta: 6,
    },
  },
  scripts: {
    tag_id_hotjar: "6487602",
    tag_id_google: "",
    tag_id_linkedin: "",
    tag_id_meta_pixel: "",
  },
  home_url: "",
  metadata: {
    title: "",
    description: "",
    favicon: "",
    keywords: undefined,
    ogImage: undefined,
  },
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_8zojFhirb",
      userPoolClientId: "6nb99vcp0t5odvfe8otkfj3eg5",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_VMSIpROPX",
      userPoolClientId: "3qg6411ka995m7le4t8gdi95bm",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
